/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 09:40:20
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-06-29 10:44:44
 */
// import Vue from "vue";
import config from "./config";
import common from "../common/common";
import pageChildren from "../common/pageChildren";
const install = (Vue) => {
    Vue.prototype.$config = config;
    Vue.prototype.$common = common;
    Vue.prototype.$pageChildren = pageChildren;
};
export default install;
